import React from "react";
import "./Hero.css";
import ImageCarousel from "../../Carousel/imageCarosel/ImageCarousel";

const Hero = ({ slides, carouselData }) => {
  return (
    <section className="hero">
      <ImageCarousel
        slides={slides || ['/assets/images/bannerDefault.jpg']}
        overlayContent={carouselData}
        showOverlay={false}
        showNavButtons={true}
        showIndicators={true}
        height="400px"
        autoPlayInterval={8000} // Reduced time
        zoomDuration={8000} // Reduced zoom duration
        showWavyBorder={true} // Show the wavy border at the bottom
        bShape={true}
      />
    </section>
  );
};

export default Hero;
